<template>
  <div>
    <form>
      <div class="form-group">
        <label class="control-label required">
          {{ $t('administration.employee.employeeCardActivator.employeeName') }}
        </label>
        <ts-search-select
          :disabled="editing"
          v-model.number="model.staff_id"
          :options="employeeOptions"
        ></ts-search-select>
        <div style="color:#cc4946;margin:4px 0 0">
          {{ errors.first('staff_id') }}
        </div>
      </div>
      <div class="form-group">
        <label class="control-label required"
          >{{ $t('administration.employee.employeeCardActivator.serialCard') }}
        </label>
        <input
          v-model="model.serial_card"
          type="text"
          class="form-control"
          :class="{ 'is-invalid': errors.has('serial_card') }"
        />
        <div class="invalid-feedback" v-if="errors.has('serial_card')">
          {{ errors.first('serial_card') }}
        </div>
      </div>
      <div class="text-right">
        <ts-button
          class="ml-2"
          color="primary"
          :disabled="saving"
          :waiting="saving"
          @click="save"
        >
          {{ $t('save') }}
        </ts-button>
      </div>
    </form>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
import FormComponent from './confirm-deactivate-old-card.vue'

export default {
  name: 'employee-card-activator-form',
  components: { FormComponent },
  data() {
    return {
      model: {
        staff_id: '',
        serial_card: ''
      },
      errors: new Errors(),
      saving: false,
      editing: false
    }
  },
  created() {
    this.loadingPreData = true

    Promise.all([this.fetchEmployees()]).then(() => {
      this.loadingPreData = false
    })
  },
  computed: {
    employeeOptions() {
      return this.$store.state.employeeCardActivator.employees.map(el => ({
        value: el.staff_id,
        text: el.name_en + '|' + el.name_kh
      }))
    }
  },
  methods: {
    ...mapActions('employeeCardActivator', ['fetchEmployees']),
    cancel() {
      this.editing = false
      this.clearForm()
      this.$emit('cancel')
      this.$router.push({ name: 'employee-card-activator' })
    },

    async checkEmployeeCardStatus(data) {
      this.errors = new Errors()
      try {
        let response = await this.$store.dispatch(
          'employeeCardActivator/checkCurrentEmployeeCardStatus',
          data
        )
        if (response.status == true) {
          this.saving = false
          this.showForm(data)
        }

        return response.status
      } catch (error) {
        this.errors = new Errors(error.errors)
        this.$toasted.error(error.message)
      }
    },

    showForm(data) {
      this.$modal.show(
        FormComponent,
        {
          data: data
        },
        {
          height: 'auto',
          width: '330px',
          scrollable: true,
          draggable: '.form-header',
          clickToClose: false
        }
      )
    },

    async save() {
      this.saving = true
      this.errors = new Errors()
      this.check = await this.checkEmployeeCardStatus(this.model)
      if (this.check == false) {
        this.saving = false
        try {
          let response = await this.$store.dispatch(
            'employeeCardActivator/create',
            this.model
          )
          this.$toasted.success(response.message)
          this.$emit('success_create')
          this.clearForm()
        } catch (error) {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        }
        this.saving = false
      }
      this.saving = false
    },

    clearForm() {
      this.model = {
        staff_id: '',
        serial_card: ''
      }
    }
  }
}
</script>
